export const classes = {
  note: 'place-center gap-[7px] text-taupe-1 dark:text-mauve-3',
  label: 'text-[11px] font-semibold',
};
